export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8287.8b850c2b.jpg";